import { useMutation, useQuery, useQueryClient } from "react-query";
import { useCookie } from "../useCookie";
import { useToast } from "../useToast";
import apiService from "../../service/apiService";
import { general } from "../../locales/general";

export const useSuggestedMessagesQuery = () => {
  const { token } = useCookie("vToken");
  const queryClient = useQueryClient();
  const { toastError, toastSuccess } = useToast();

  const { data, isLoading } = useQuery(["getAllChatSuggestions"], (query) => {
    return apiService.MakeGetRequest("rides/chat-suggestion", token);
  });

  const deleteSuggestedMessage = useMutation((id: string) => {
    return apiService.MakeDeleteRequest(`rides/chat-suggestion/${id}`, token);
  });

  return {
    suggestedMessages: data,
    fetchingSuggestedMessages: isLoading,
    deleteSuggestedMessage(id: string) {
      deleteSuggestedMessage.mutate(id, {
        onError(error) {
          toastError(general.fr.message.operationFailed);
        },
        onSuccess() {
          toastSuccess(general.fr.message.chatSuggestionDeleted);
          queryClient.invalidateQueries("getAllChatSuggestions");
        },
      });
    },
    mutating: deleteSuggestedMessage.isLoading,
  };
};
